// @flow
import * as React from "react";
import { useFirestore, useFirestoreCollectionData } from "reactfire";
import { Area, AreaChart, ResponsiveContainer } from "recharts";

type Props = {
  id: string,
};

function RankingsRowGraph({ id }: Props) {
  const firestore = useFirestore();
  const dataRef = firestore
    .collection("sams")
    .doc("rankings")
    .collection("ranking")
    .doc(id.toString())
    .collection("weekly");
  const data = useFirestoreCollectionData(dataRef);

  const graphData = data.map((d) => ({
    ...d,
    computedPlace: 13 - d.place,
  }));

  const amountOfWeeks = graphData.length;
  const firstTrendPoint = amountOfWeeks >= 3 ? amountOfWeeks - 3 : 0;
  const lastTrendPoint = amountOfWeeks - 1;

  const positiveTrend =
    graphData[firstTrendPoint].computedPlace <=
    graphData[lastTrendPoint].computedPlace;
  const trendColor = positiveTrend ? "#76D571" : "red";

  return (
    <ResponsiveContainer width="100%" height={40}>
      <AreaChart data={graphData}>
        <defs>
          <linearGradient id={`colorUv${id}`} x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor={trendColor} stopOpacity={0.8} />
            <stop offset="95%" stopColor={trendColor} stopOpacity={0} />
          </linearGradient>
        </defs>
        <Area
          type="linear"
          dataKey="computedPlace"
          stroke={trendColor}
          fillOpacity={1}
          fill={`url(#colorUv${id})`}
        />
      </AreaChart>
    </ResponsiveContainer>
  );
}

export default RankingsRowGraph;
